import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-contacts-add',
  templateUrl: './campaign-contacts-add.component.html',
  styleUrls: ['./campaign-contacts-add.component.css']
})
export class CampaignContactsAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
